<template>
  <Modal :value="!!id" width="400" class="modal" @on-visible-change="change">
    <div style="text-align:center">
      <div class="icon"></div>
      <div class="text">{{$t('msg.m50')}}</div>
    </div>
    <div slot="footer">
      <Button size="large" @click="id=null">{{$t('btn.b29')}}</Button>
      <Button class="d" size="large" @click="cancel">{{$t('btn.b30')}}</Button>
    </div>
  </Modal>
</template>
<script>
/* 删除确认 */
export default {
  data() {
    return {
      id: null
    };
  },
  methods: {
    async cancel() {
      let res = await this.$axios.post("/Member/RZJLoan/CancelAutomatic", {
        automaticId: this.id
      });
      res.throw();
      if (!res.err) {
        this.id = null;
        this.$emit("done");
        this.$store.dispatch("user/getAssets");
      }
    },
    change(v) {
      if (!v) this.id = null;
    }
  }
};
</script>
<style lang="less" scoped>
.icon {
  width: 100px;
  height: 100px;
  background: url(../../../assets/public_undo.png) no-repeat;
  margin: 20px auto 16px;
}
.text {
  font-size: 16px;
  line-height: 24px;
  color: #000;
}
.modal {
  /deep/ .ivu-modal-footer {
    padding: 0 0 20px;
    text-align: center;
    .ivu-btn {
      border-radius: 0;
      width: 45%;
      font-size: 16px;
      color: #000;
      &.d {
        color: #f5222d;
      }
    }
  }
}
</style>